/* eslint-disable react-hooks/exhaustive-deps */
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

export type buttonStatus = "validado" | "completo" | "editar" | "llenar";

export interface buttonProps {
  disabled: boolean;
  buttonLabel: string;
  backgroundColor: string;
  color?: string;
}

// Función helper para convertir booleanos a strings
const normalizeFormStatus = (status: string | boolean | null | undefined): string | null => {
  if (typeof status === "boolean") {
    return status === true ? "COMPLETO" : "PENDIENTE";
  }
  return status || null;
};

export interface CustomButtonExpedienteProps {
  disabled?: boolean;
  onClick?: () => void;
  onClickDisabled?: () => void;
  formStatus?: string | boolean | null;
  fakeDisabled?: boolean;
  documentStatus?: boolean | null;
  type?: "form" | "validation";
}

const CustomButtonExpedienteAvalAdicionalV2: React.FC<CustomButtonExpedienteProps> = ({
  onClick,
  disabled,
  fakeDisabled,
  formStatus,
  type,
}) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [btnParams, setBtnParams] = useState<buttonProps>({
    disabled: false,
    buttonLabel: "Llenar",
    backgroundColor: theme?.palette?.primary?.main,
    color: "#FFFFFF",
  });

  useEffect(() => {
    const normalizedStatus = normalizeFormStatus(formStatus);

    if (normalizedStatus === "VALIDADO") {
      setBtnParams({
        disabled: true,
        buttonLabel: "Validado",
        backgroundColor: theme?.palette?.primary?.light,
        color: theme?.palette?.primary?.main,
      });
    } else if (normalizedStatus === "COMPLETO") {
      setBtnParams({
        disabled: true,
        buttonLabel: "Completo",
        backgroundColor: theme?.palette?.primary?.dark,
        color: theme?.palette?.primary?.light,
      });
    } else if (normalizedStatus === "INCIDENCIA") {
      setBtnParams({
        disabled: false,
        buttonLabel: type === "validation" ? "Volver a validar" : "Editar",
        backgroundColor: "#F2704F",
        color: "#FFFFFF",
      });
    } else {
      // normalizedStatus === "PENDIENTE" o null/undefined
      setBtnParams({
        disabled: false,
        buttonLabel: type === "validation" ? "Validar" : "Llenar",
        backgroundColor: theme?.palette?.primary?.main,
        color: "#FFFFFF",
      });
    }
  }, [formStatus]);

  return (
    <Button
      variant="expediente"
      size={isMobileOrTablet ? "small" : "medium"}
      onClick={onClick}
      disabled={btnParams.disabled || disabled}
      sx={{
        backgroundColor: btnParams.backgroundColor,
        color: btnParams.color,
        opacity: fakeDisabled ? 0.5 : 1,
        "&:hover": {
          backgroundColor: btnParams.backgroundColor,
        },
        "&.Mui-disabled": {
          backgroundColor: btnParams.backgroundColor,
          color: btnParams.color,
          opacity: 1,
        },
      }}
    >
      {btnParams.buttonLabel}
    </Button>
  );
};

export default CustomButtonExpedienteAvalAdicionalV2;
